import React, { useEffect, useContext, useState } from "react";
import { DataContext } from '../../data/DataContext';
import Input from "../controls/Input";
import DropDown from "../controls/DropDown";
import http from '../../../../services/http';
import { endPoints } from '../../../../utils/constanst';
import { buildTarficacionData } from "../../data/Data";
import tarificar from '../../services/Tarficar';
import useCallApi from '../../../../hooks/useCallApi';
import Modal from "react-modal";





const Step2 = () => {

    const { SOA, setSOA, changeHandler, init } = useContext(DataContext);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {

        if (init) {
            // cargarCatalogos(SOA.idPlan);
        }
    }, [init]);

    const load = (data) => { setSOA({ ...SOA, cargando: data }) };


    const cargarCatalogos = async (planId) => {
        const [marcas, usos, departamentos] = await Promise.all([
            http(endPoints.brands(planId)).get(),
            http(endPoints.vhUses).get(),
            http(endPoints.department('505')).get(),

        ]);
        SOA.setCatalogos({ marcas, usos, departamentos });
    }



    useEffect(() => {
        setLoading(true);
        Promise.all([
            http(endPoints.brands(SOA.idPlan)).get(),
            http(endPoints.vhUses).get(),
            http(endPoints.coverages(SOA.idPlan)).get(),
            http(endPoints.department('505')).get(),
            http(endPoints.vhClass).get()])
            .then(r => {
                SOA.setCatalogos({
                    marcas: r[0],
                    usos: uniqueArray(r[1]), //r[1],
                    coberturas: r[2],
                    departamentos: r[3],
                    clase: r[4]
                });

            }).then(() => { setLoading(false); });
    }, [SOA.idPlan]);

    const uniqueArray = (data) => {
        const ids = data.map(o => o.value)
        const filtered = data.filter(({ value }, index) => !ids.includes(value, index + 1))
        return filtered;
        // return Object.keys(filtered).sort().reduce((r, k) => (r[k] = filtered[k], r), {})
    };

    useEffect(() => {

        if (SOA.marca != 0 && SOA.modelo != 0 && SOA.anio != 0 && SOA.usoDelVehiculo != 0) {
            setLoading(true);
            http(endPoints.datasheet(SOA.idPlan, SOA.marca, SOA.modelo, SOA.anio)).get()
                .then(r => {
                    setSOA({ ...SOA, datasheet: true });
                    SOA.setTarificacion(r);
                }).catch(c => {
                    console.log("🚀 ~ file: Step2.jsx ~ line 80 ~ useEffect ~ c", c)
                    setSOA({ ...SOA, datasheet: false, mensaje: "Favor seleccionar otro modelo" });
                    handleShow();
                })
                .finally(() => { setLoading(false) });
        }
    }, [SOA.anio, SOA.marca, SOA.modelo, SOA.usoDelVehiculo]);

    const marcaHandler = (event) => {
        setLoading(true);
        setSOA({ ...SOA, [event.target.name]: event.target.value, modelo: '', marcaDesc: event.target.desc });
        http(endPoints.models(SOA.idPlan, event.target.value)).get()
            .then(data => {
                SOA.setCatalogos({ modelos: data });

            }).finally(() => { setLoading(false) });
    }

    const modeloHandler = (event) => {
        setLoading(true);
        //SOA.setTarificacion({ ...SOA.tarificacion, [event.target.name]: event.target.value, });
        setSOA({ ...SOA, [event.target.name]: event.target.value, modeloDesc: event.target.desc });
        http(endPoints.lastYear(SOA.idPlan, SOA.marca, event.target.value)).get()
            .then(data => { SOA.setCatalogos({ anios: data }); }).finally(() => { setLoading(false) });

    }

    const usoHandler = (event) => {
        setSOA({ ...SOA, [event.target.name]: event.target.value });
    }





    return (
        <div className="step">
            <div className="step-container-soa">
                <div className="mt-15">
                    <span className="title2">
                        Detalles de tu vehículo
                </span>
                </div>
                <div className="mt-15 mb-30">
                    <span className="title3">
                        Ingresá los siguientes campos de acuerdo a la circulación de tu vehículo
                </span>
                </div>
                <Input label="Placa del vehículo" value={SOA.placa} field="placa" onChange={changeHandler}  ></Input>
                <DropDown isrequired={true} containBlank={true} label="Marca" dataProvider={SOA.catalogos.marcas} valueSelect={SOA.marca} fieldSelect="marca" field="marca" onChangeSelect={marcaHandler} onChange={marcaHandler} />
                <DropDown useDesc={true} isrequired={true} containBlank={true} label="Modelo" dataProvider={SOA.catalogos.modelos} valueSelect={SOA.modelo} fieldSelect="modelo" field="modelo" onChangeSelect={modeloHandler} onChange={modeloHandler} />
                <DropDown isrequired={true} typeImgInfo="Placa" useIconInfo={false} containBlank={true} label="Año" dataProvider={SOA.catalogos.anios} valueSelect={SOA.anio} fieldSelect="anio" field="anio" onChangeSelect={changeHandler} />
                <DropDown isrequired={true} containBlank={true} label="Clase" dataProvider={SOA.catalogos.clase} valueSelect={SOA.claseVehiculo} fieldSelect="claseVehiculo" field="claseVehiculo" onChangeSelect={changeHandler} />
                <DropDown isrequired={true} typeImgInfo="Placa" useIconInfo={false} containBlank={true} label="Uso del vehículo" dataProvider={SOA.catalogos.usos} valueSelect={SOA.usoDelVehiculo} fieldSelect="usoDelVehiculo" field="usoDelVehiculo" isrequired={true} onChangeSelect={usoHandler} />
                <Input typeImgInfo="Color" label="Color del vehículo" useIconInfo={true} value={SOA.colorVehiculo} field="colorVehiculo" onChange={changeHandler}></Input>
                <Input typeImgInfo="Chasis" label="Número de chasis" useIconInfo={true} value={SOA.numeroChasis} field="numeroChasis" onChange={changeHandler}></Input>
                <Input typeImgInfo="Motor" label="Número de motor" useIconInfo={true} value={SOA.numeroMotor} field="numeroMotor" onChange={changeHandler}></Input>
            </div>
            <Modal className="modal" isOpen={loading} show={loading} ariaHideApp={false}>
                <div className="dialog-center-content">
                    <p className="text-center">Cargando...</p>
                </div>
            </Modal>
            <Modal className="modal" isOpen={show} show={show} ariaHideApp={false}>
                <div className="modal-title">
                    <span className="txt-title-modal">Información</span>
                </div>
                <div className="modal-body-info">
                    {SOA.mensaje}
                </div>
                <div className="modal-footer">
                    <button className="modal-btn-close" onClick={handleClose}>Cerrar</button>
                </div>
            </Modal>
        </div>
    );
}

export default Step2;

